module.exports = __webpack_public_path__ + "static/media/webfont.21efb476.ttf";